import React from 'react';
import Typography from '@material-ui/core/Typography';

const MoreDetails = () => {
  return (
    <>
      <Typography
        component='h1'
        variant='h2'
        align='center'
        color='textPrimary'
        gutterBottom>
        We're unable to to offer a discount at this time.
      </Typography>
      <Typography variant='h5' align='center' color='textSecondary' paragraph>
      Please see below for more details.
      </Typography>
    </>
  );
};

export default MoreDetails;
